import {
  AirConditioningIcon,
  AssistedLivingIcon,
  BalconyIcon,
  BanIcon,
  BasketballCourtIcon,
  BikeStorageIcon,
  BilliardsRoom,
  BowlingAlleyIcon,
  BuiltinVacuumIcon,
  CarChargingIcon,
  CaretakerIcon,
  CarValetIcon,
  ChangeRoomIcon,
  CheckIcon,
  ClubhouseIcon,
  ConcieregeIcon,
  CourtyardIcon,
  DaycareIcon,
  DogMindingIcon,
  DoormanIcon,
  ElevatorIcon,
  ExerciseCentreIcon,
  FamilyRoomIcon,
  FireplaceIcon,
  GamesRoomIcon,
  GarbageIcon,
  GardenIcon,
  GatedComplexIcon,
  GourmetKitchensIcon,
  GuestSuiteIcon,
  GymIcon,
  HighCeilingsIcon,
  HotTubIcon,
  IndoorBasketballCourtIcon,
  IndoorPoolIcon,
  InsuiteLaundryIcon,
  InsuiteStorage,
  LaundryIcon,
  LibraryIcon,
  LoungeIcon,
  MasssageSpaRoomIcon,
  MediaRoomIcon,
  MeetingRoomIcon,
  OutdoorBasketballCourtIcon,
  OutdoorPoolIcon,
  ParkingIcon,
  PatioDeckTerraceIcon,
  PetsIcon,
  PetsNotAllowedIcon,
  PlaygroundIcon,
  PoolIcon,
  PrivateYardIcon,
  RecreationCentreIcon,
  RecreationRoomIcon,
  RestaurantIcon,
  RVParkingIcon,
  SaunaIcon,
  SaunaSteamRoomIcon,
  SecuredUndergroundParkingIcon,
  SecurityIcon,
  SecuritySystemIcon,
  SharedLaundryIcon,
  SmokingAreaIcon,
  SquashCourtIcon,
  SteamRoomIcon,
  StorageAreaIcon,
  TableTennisRoomIcon,
  TennisCourtIcon,
  VaultedCeilingsIcon,
  VisitorsParking,
  WallClimbingIcon,
  WasteDisposalChuteIcon,
  WheelchairAccessibleIcon,
  WorkshopIcon,
  YogaRoomIcon
} from '@/components/icons'

const icons = {
  air_conditioning: AirConditioningIcon,
  assisted_living: AssistedLivingIcon,
  balcony: BalconyIcon,
  basketball_court: BasketballCourtIcon,
  bike_storage: BikeStorageIcon,
  billiards_room: BilliardsRoom,
  bowling_ally: BowlingAlleyIcon,
  builtin_vacuum: BuiltinVacuumIcon,
  car_charging: CarChargingIcon,
  car_valet: CarValetIcon,
  caretaker: CaretakerIcon,
  change_room: ChangeRoomIcon,
  clubhouse: ClubhouseIcon,
  concierge: ConcieregeIcon,
  courtyard: CourtyardIcon,
  daycare: DaycareIcon,
  dog_minding: DogMindingIcon,
  doorman: DoormanIcon,
  elevator: ElevatorIcon,
  exercise_centre: ExerciseCentreIcon,
  family_room: FamilyRoomIcon,
  fireplace: FireplaceIcon,
  games_room: GamesRoomIcon,
  garbage_pickup: GarbageIcon,
  garbage_valet: GarbageIcon,
  garden: GardenIcon,
  gated_complex: GatedComplexIcon,
  gourmet_kitchens: GourmetKitchensIcon,
  guest_suite: GuestSuiteIcon,
  gym: GymIcon,
  high_ceilings: HighCeilingsIcon,
  hot_tub: HotTubIcon,
  indoor_basketball_court: IndoorBasketballCourtIcon,
  indoor_pool: IndoorPoolIcon,
  insuite_laundry: InsuiteLaundryIcon,
  insuite_storage: InsuiteStorage,
  laundry: LaundryIcon,
  library: LibraryIcon,
  lounge: LoungeIcon,
  massage_spa_room: MasssageSpaRoomIcon,
  media_room: MediaRoomIcon,
  meeting_room: MeetingRoomIcon,
  outdoor_basketball_court: OutdoorBasketballCourtIcon,
  outdoor_pool: OutdoorPoolIcon,
  parking: ParkingIcon,
  patio_deck_terrace: PatioDeckTerraceIcon,
  playground: PlaygroundIcon,
  pool: PoolIcon,
  private_yard: PrivateYardIcon,
  recreation_centre: RecreationCentreIcon,
  recreation_room: RecreationRoomIcon,
  restaurant: RestaurantIcon,
  rv_parking: RVParkingIcon,
  sauna: SaunaIcon,
  sauna_steam_room: SaunaSteamRoomIcon,
  secured_underground_parking: SecuredUndergroundParkingIcon,
  security: SecurityIcon,
  security_system: SecuritySystemIcon,
  shared_laundry: SharedLaundryIcon,
  smoking_area: SmokingAreaIcon,
  squash_court: SquashCourtIcon,
  steam_room: SteamRoomIcon,
  storage_area: StorageAreaIcon,
  table_tennis_room: TableTennisRoomIcon,
  tennis_court: TennisCourtIcon,
  vaulted_ceilings: VaultedCeilingsIcon,
  visitors_parking: VisitorsParking,
  wall_climbing: WallClimbingIcon,
  waste_disposal_chute: WasteDisposalChuteIcon,
  wheelchair_accessible: WheelchairAccessibleIcon,
  workshop: WorkshopIcon,
  yoga_room: YogaRoomIcon,
  cats_allowed: CheckIcon,
  cats_not_allowed: BanIcon,
  dogs_allowed: CheckIcon,
  max_1_pet_allowed: CheckIcon,
  max_2_pets_allowed: CheckIcon,
  petsNotAllowed: PetsNotAllowedIcon,
  pets_not_allowed: PetsNotAllowedIcon,
  petsAllowed: PetsIcon,
  pets_allowed: PetsIcon,
  rentals_allowed: CheckIcon,
  rentals_allowed_with_restrictions: CheckIcon,
  pets_allowed_with_restrictions: CheckIcon
}

const Icon = ({ id, ...rest }) => {
  const Current = icons[id]
  return Current ? <Current {...rest} /> : null
}

export default Icon
